export default __webpack_public_path__ + "static/media/urskog-fro.51d3a975.jpeg";